<template>
  <div
    class="non-auth-layout"
    style="animation-duration: 0.7s"
  >
    <main class="container position-relative">
      <div class="row">
        <div class="col-20 wrapper">
          <router-view />
        </div>
      </div>
      <img
        class="decor d-none d-md-inline"
        :src="$publicPath + 'img/dots-1.png'"
      >
      <img
        v-if="$route.name === 'register-step2'"
        class="decor2 d-none d-md-inline"
        :src="$publicPath + 'img/dots-2.png'"
      >
    </main>
  </div>
</template>

<script>
export default {
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.non-auth-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow: hidden;
  z-index: 0;
  .wrapper {
      background: #FFFFFF;
      box-shadow: 0px 13.8611px 55.4444px #F2F5FA;
      border-radius: 8px;
      overflow: hidden;
      @include media-breakpoint-down(sm) {
          border-radius: 0;
      }
  }
  .decor {
      position: absolute;
      bottom: -85px;
      right: -65px;
      z-index: -1;
  }
  .decor2 {
      position: absolute;
      bottom: -58px;
      left: 0;
      z-index: -1;
  }
  ::v-deep {
    .add-border {
      border: 2px solid $nh-gray;
      @include media-breakpoint-up(md) {
          border-radius: 8px;
          &.order-md-2 {
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
              border-left: none;
          }
          &:not(.order-md-2) {
              border-right: none;
              border-top-right-radius: 0;
              border-bottom-right-radius: 0;
          }
      }
      @include media-breakpoint-down(sm) {
          border-bottom: none;
          border-top: none;
      }
      @include media-breakpoint-down(xs) {
          border: none;
      }
    }
    .content-column {
      padding: 4rem 2rem;
      .vertical-fill {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-height: 400px;
          .title {
              position: relative;
              img {
                  position: absolute;
                  left: 0;
                  top: 50%;
                  transform: translateY(-50%);
                  @media(max-width: 400px) {
                  transform: none;
                  top: -34px;
                  }
              }
          }
      }
    }
    label {
      text-align: left;
      @media only screen and (max-width: 400px) {
          @include make-col(20, 20);
          text-align: center;
      }
    }
  }
}

/* forms */
::v-deep {
  .form-control {
    border: 1.5px solid $warning;
    border-radius: 5px;
    padding: 1.5rem 2rem;
  }
  .custom-control-label::before {
    border-color: $warning;
  }

  .custom-select {
    border-color: $warning;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active  {
      -webkit-box-shadow: 0 0 0 30px #fffcc8 inset !important;
  }

  .agree-input {
      label {
          text-align: left;
          padding-left: 1.8rem;
      }
  }
}
</style>
